import { TypedUseSelectorHook, useDispatch, useSelector, useStore } from "react-redux";
import type { RootState, AppDispatch } from "@/app/store";
import { debounce } from "lodash";

// Use throughout your app instead of plain `useDispatch`, `useSelector` and `useStore`
// This is a custom hook that wraps the useDispatch, useSelector and useStore hooks from
// react-redux with the types of our store
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
// Gives access to store.getState() at call time, for code that must read the live store
// synchronously (e.g. an atomic check-then-act) rather than a render-time useSelector snapshot,
// which can be one dispatch behind inside the same synchronous call.
export const useAppStore = () => useStore<RootState>();

// Helper function to create a debounced thunk
export function createDebouncedThunk(action: any, wait: number) {
    const debounced = debounce(action, wait, {
        leading: true,
        trailing: false,
    });

    return (...args: any) =>
        (dispatch: any, getState: any) => {
            return debounced(() => dispatch(action(...args)))(dispatch, getState);
        };
}
